import * as React from 'react';

const HeartFilled24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 5.8c-.95-1.233-2.34-2.22-3.86-2.612-2.343-.605-4.627.281-6.012 2.22-2.511 3.514-.45 7.717 2.474 10.316l.002.002 5.54 4.58a2.8 2.8 0 0 0 3.69.002l5.56-4.581.004-.003c2.924-2.599 4.985-6.803 2.474-10.316-1.386-1.94-3.67-2.825-6.014-2.22-1.518.393-2.91 1.38-3.859 2.612Z"
  }
));
HeartFilled24.Size = 24;
HeartFilled24.Title = "HeartFilled";

export { HeartFilled24 as default };
